import { render, staticRenderFns } from "./jkfx.vue?vue&type=template&id=b2d9431a&"
import script from "./jkfx.vue?vue&type=script&lang=js&"
export * from "./jkfx.vue?vue&type=script&lang=js&"
import style0 from "./jkfx.vue?vue&type=style&index=0&id=b2d9431a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports